import { titleCase } from 'utilities/utilities';
import { useState } from 'react';

const TextInput = ({
  className,
  error,
  placeholder,
  onChange,
  value = '',
  width,
  maxWidth,
  disabled,
  password = false,
  autoCapitalize,
  autoTitleCase,
  autocomplete,
  type,
  name
}) => {
  const [enableTitleCase, setEnableTitleCase] = useState(autoTitleCase);
  const [prevLength, setPrevLength] = useState(value.length);

  const checkTitleCaseOnChange = e => {
    if (!onChange) {
      return;
    }
    let _enableTitleCase = enableTitleCase;
    if (_enableTitleCase) {
      if (prevLength >= e.target.value.length) {
        _enableTitleCase = false;
      }
      setPrevLength(e.target.value.length);
    }
    if (autoTitleCase && e.target.value.length == 0) {
      _enableTitleCase = true;
      setPrevLength(0);
    }
    if (_enableTitleCase) {
      e.target.value = titleCase(e.target.value);
    }
    setEnableTitleCase(_enableTitleCase);
    onChange(e);
  };

  return (
    <div
      className={`control text-input ${className}`}
      style={{ display: 'flex', justifyContent: 'center', fontSize: '18px' }}
    >
      <input
        className={`input ${error ? 'is-danger' : ''}`}
        type={type ? type : password ? 'password' : 'text'}
        name={name}
        placeholder={placeholder}
        onChange={checkTitleCaseOnChange}
        value={value}
        width={width}
        style={{ maxWidth }}
        disabled={disabled}
        autoCapitalize={autoCapitalize}
        autoComplete={autocomplete}
      />
      <style jsx>{`
        input {
          height: 3rem;
          padding: 1rem 1rem 1rem 1rem;
        }
      `}</style>
    </div>
  );
};

export default TextInput;
